import { render, staticRenderFns } from "./MusicOnHold.vue?vue&type=template&id=4b1b6dc9&"
import script from "./MusicOnHold.vue?vue&type=script&lang=js&"
export * from "./MusicOnHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports